import { Injectable } from "@angular/core";
import { FormArray, FormBuilder, Validators } from "@angular/forms";
import { BaseFormGroupService } from "../../util/components/modal/base-form-group.service";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { ToastrService } from "ngx-toastr";
import { Observable } from "rxjs";
import { UserService } from "../../api/services/user.service";
import { UserDto } from "../../api/models/user-dto";
import { AppAbility } from "../../util/service/auth.service";
import { CaslAction } from "../../server/enums/casl-action.enum";
import { EntityTyp } from "../../util/enums/entity-typ.enum";

@Injectable({
  providedIn: "root",
})
export class UserFormGroupService extends BaseFormGroupService<UserDto> {
  entitySingular = "Benutzer";

  constructor(
    private fb: FormBuilder,
    public override modal: NgbActiveModal,
    protected toastr: ToastrService,
    private userService: UserService,
    private ability: AppAbility
  ) {
    super(modal, toastr);
  }

  /* Rollen */
  get rollenArray(): FormArray {
    return this.formGroup.get("rollen") as FormArray;
  }

  initFormGroup() {
    this.formGroup = this.fb.group({
      email: ["", [Validators.required, Validators.email]],
      role: [null, [Validators.required]],
      version: [0, [Validators.required]],
      officeIds: [[]],
      sendIncidentMail: [false],
    });

    this.setPermissions();
  }

  protected create(mergedEntity: UserDto): Observable<UserDto> {
    return this.userService.userControllerCreate({ body: mergedEntity });
  }

  protected update(mergedEntity: UserDto): Observable<UserDto> {
    return this.userService.userControllerUpdate({
      body: mergedEntity,
    });
  }

  protected reloadEntity(id: number): Observable<UserDto> {
    return this.userService.userControllerFindOne({ id });
  }

  protected updateFormGroup(entity: UserDto) {
    this.formGroup.patchValue(entity, { emitEvent: false });
    this.setPermissions();
  }

  private setPermissions() {
    if (this.ability.can(CaslAction.Update, EntityTyp.User)) {
      return;
    }
    this.formGroup.disable({ emitEvent: false });
  }
}
